export default {
  EN: "en",
  DE: "de"
};
